document.querySelectorAll('.mega-menu').forEach((menu) => {
  const summary = menu.querySelector('summary');

  summary.addEventListener('mouseenter', () => {
    // Add the class to trigger the open animation
    menu.classList.add('list-menu--megamenu-visible');
    menu.setAttribute('open', 'true');
  });

  menu.addEventListener('mouseleave', (e) => {
    // Prevent immediate closing
    if (menu.hasAttribute('open')) {
      e.preventDefault(); // Stop default behavior (closing)
      menu.classList.add('closing'); // Add closing class to start animation
      menu.classList.remove('list-menu--megamenu-visible');
    }
  });

  // When the closing animation ends, actually close the details
  menu.addEventListener('animationend', (e) => {
    if (e.animationName === 'close') {
      // Remove the 'open' attribute and the closing class after animation
      menu.removeAttribute('open');
      menu.classList.remove('closing');
    }
  });
});
